import { render, staticRenderFns } from "./KuaishouUpload.vue?vue&type=template&id=f203d490&scoped=true"
import script from "./KuaishouUpload.vue?vue&type=script&lang=js"
export * from "./KuaishouUpload.vue?vue&type=script&lang=js"
import style0 from "./KuaishouUpload.vue?vue&type=style&index=0&id=f203d490&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f203d490",
  null
  
)

export default component.exports